import { render, staticRenderFns } from "./subbudget.vue?vue&type=template&id=f73b31f0&scoped=true&"
import script from "./subbudget.vue?vue&type=script&lang=js&"
export * from "./subbudget.vue?vue&type=script&lang=js&"
import style0 from "./subbudget.vue?vue&type=style&index=0&id=f73b31f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73b31f0",
  null
  
)

export default component.exports